function LayerThreeSpacing(props){

    const contentViewWidth = props.contentViewWidth

    return (
        <div className='bg-moon-gray' style={{height: '1vh', position: 'fixed', width: `${contentViewWidth}px`}}></div>
    )
}

export default LayerThreeSpacing